
export enum LinkedFormControlActionType {
  Create = 0,
  Edit = 1,
  View = 2,
  Search = 3,
}